<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>投料查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="5">
              <el-form-item label="工单号" prop="orderno">
                <el-input v-model="searchform.orderno" style="width: 80%" clearable placeholder="请输入工单号" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="成品编码" prop="product_code">
                <el-input v-model="searchform.product_code" style="width: 80%" clearable placeholder="请输入成品编码" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="批次号" prop="material_batchno">
                <el-input v-model="searchform.material_batchno" style="width: 80%" clearable placeholder="请输入批次号" />
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-button v-permission="['materialquery_select']" type="primary" icon="el-icon-search"
                @click="searchform.pageindex = 1; search()">搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button v-permission="['materialquery_export']" :loading="downloadLoading" type="primary"
                icon="document" @click="handleDownload">导出Excel</el-button>
              <el-button v-permission="['materialquery_add']" type="primary"
                @click="add.addshow = !add.addshow">新增投料记录</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 新增修改模块       -->
      <material-Add :add="add" :search="search" />
      <material-Update ref="updatechild" :search="search" />

      <el-divider />
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" border style="width: 90%">
            <el-table-column prop="orderno" label="工单编号" show-overflow-tooltip min-width="100" />
            <el-table-column prop="product_code" label="产品编号" show-overflow-tooltip min-width="100" />
            <el-table-column prop="product_name" label="产品名称" show-overflow-tooltip min-width="100" />
            <el-table-column prop="product_batchno" label="产品批次" show-overflow-tooltip min-width="100" />
            <el-table-column prop="material_code" label="投料编码" />
            <el-table-column prop="material_name" label="投料名称" show-overflow-tooltip min-width="100" />
            <el-table-column prop="material_batchno" label="投料批次号" min-width="100" />
            <el-table-column prop="supplier_name" label="供应商" min-width="150" />
            <el-table-column prop="material_manufacturer" label="原料生产商" min-width="150" />
            <el-table-column prop="material_manufacturer_place" label="原料生产商产地" min-width="150" />
            <el-table-column label="操作" min-width="150">
              <template slot-scope="scope">
                <el-button v-permission="['materialquery_update']" type="primary"
                  @click="materialupdaterow(scope.row)">修改</el-button>
                <el-button v-permission="['materialquery_delete']" type="danger" @click="deleterow(scope.row.id)">
                  删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <br />

          <el-pagination background :current-page.sync="currentPage" :page-sizes="pagesizes"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count" @current-change="currentchange"
            @size-change="pagesize" />
          <el-divider />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { MaterialsBatchLogPagelist, MaterialsBatchLogdel } from "@/api/plant";
import materialAdd from "./components/materialAdd";
import materialUpdate from "./components/materialUpdate";
export default {
  name: "materialquery",
  components: { materialAdd, materialUpdate },
  data() {
    return {
      // 基础数据
      add: {
        addshow: false,
      },
      // 基础数据
      listLoading: true,
      dialogVisible: false,
      editVisible: false,
      tableData: [],
      // 下拉数据
      status: [
        {
          key: 0,
          label: "启用",
        },
        {
          key: 1,
          label: "关闭",
        },
      ],
      // 分页数据
      pagesizes: [10, 20, 40, 50, 100],
      total_count: 1,
      currentPage: 1,
      // 搜索表单数据
      searchform: {
        orderno: "",
        material_name: "",
        material_batchno: "",
        pageindex: 1,
        pagesize: 10,
      },
      obj: {
        productCode: "",
        productName: "",
      },
      form: {
        id: "", // 查看详情与删除按钮传参
      },
      // 导出表格变量
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
    };
  },
  mounted() {
    // 请求部门列表数据并且便利到表格
    this.Tabledata();
    // 请求下拉菜单数据 部门菜单
  },
  methods: {
    // 删除按钮事件
    deleterow(id) {
      this.$confirm('此操作将永久删除该行记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          MaterialsBatchLogdel({
            id: id
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.search()
            } else {
              this.$message({
                type: 'woring',
                message: '删除失败!请检查字段'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 修改原料投料
    materialupdaterow(row) {
      console.log(row);
      this.$refs.updatechild.form = row;
      this.$refs.updatechild.changematerial(row.material_code);
      this.$refs.updatechild.show = true;
    },
    // 请求表格数据
    Tabledata(bb) {
      MaterialsBatchLogPagelist({
        orderno: this.searchform.orderno,
        product_code: this.searchform.product_code,
        material_batchno: this.searchform.material_batchno,
        pageindex: this.searchform.pageindex,
        pagesize: this.searchform.pagesize,
      }).then((response) => {
        this.currentPage = response.data.page_index;
        this.tableData = response.data.data;
        this.total_count = response.data.total_count;
        this.listLoading = false;
        console.log(response.data);
      });
    },
    // 搜索事件
    search() {
      this.Tabledata();
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.Tabledata();
    },
    // 分页跳转事件
    currentchange(pageindex) {
      this.searchform.pageindex = pageindex;
      MaterialsBatchLogPagelist({
        orderno: this.searchform.orderno,
        product_code: this.searchform.product_code,
        material_batchno: this.searchform.material_batchno,
        pageindex: this.searchform.pageindex,
        pagesize: this.searchform.pagesize,
      }).then((response) => {
        this.currentPage = response.data.page_index;
        this.tableData = response.data.data;
        this.total_count = response.data.total_count;
        this.listLoading = false;
        console.log(response.data);
      });
    },
    // 分页每页显示条数事件
    pagesize(pagesize) {
      this.searchform.pagesize = pagesize;
      this.search();
    },
    // 表格单行点击
    danhang(row) {
      this.form.id = row.id;
    },
    // 跳转新增页按钮
    productadd() {
      this.$router.push({
        path: "/productaddedit",
      });
    },
    // 查看产品详情跳转
    prodcutnews(id) {
      console.log(id);
      this.$router.push({
        path: "/productpages",
        query: {
          id: id,
        },
      });
    },
    // 导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      MaterialsBatchLogPagelist({
        orderno: this.searchform.orderno,
        product_code: this.searchform.product_code,
        material_batchno: this.searchform.material_batchno,
        pageindex: this.searchform.pageindex,
        pagesize: this.searchform.pagesize,
      }).then((response) => {
        this.tableDataDownload = response.data.data;
        this.listLoading = false;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "工单编号",
            "产品编码",
            "产品名称",
            "产品批次",
            "投料编码",
            "投料名称",
            "投料批次号",
            "供应商",
            "原料生产商",
            "原料生产商产地"
          ];
          const filterVal = [
            "orderno",
            "product_code",
            "product_name",
            "product_batchno",
            "material_code",
            "material_name",
            "material_batchno",
            "supplier_name",
            "material_manufacturer",
            "material_manufacturer_place"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.handle-box {
  margin-bottom: 20px;
}

.handle-input {
  width: 160px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.table {
  width: 100%;
  font-size: 14px;
}

.mr10 {
  margin-right: 10px;
}
</style>
